import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "d-flex justify-content-end align-items-center mb-4" };
const _hoisted_4 = { class: "me-2 fw-medium text-black" };
const _hoisted_5 = { class: "ms-3 d-flex gap-2" };
const _hoisted_6 = ["onClick", "title"];
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-md-6" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = { class: "col-md-12" };
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_15 = { class: "mb-0" };
const _hoisted_16 = { class: "col-md-12" };
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = { class: "mb-0" };
const _hoisted_20 = { class: "col-md-12" };
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_22 = { class: "d-flex justify-content-between align-items-center mb-3" };
const _hoisted_23 = { class: "d-block text-black fw-semibold mb-0" };
const _hoisted_24 = {
    key: 0,
    class: "badge bg-success"
};
const _hoisted_25 = {
    key: 1,
    class: "badge bg-warning"
};
const _hoisted_26 = { class: "card border-0 shadow-sm mb-3" };
const _hoisted_27 = { class: "card-body" };
const _hoisted_28 = { class: "row" };
const _hoisted_29 = { class: "col-md-12 mb-3" };
const _hoisted_30 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_31 = ["placeholder"];
const _hoisted_32 = { class: "col-md-12 mb-3" };
const _hoisted_33 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_34 = { class: "mb-0" };
const _hoisted_35 = { class: "col-md-12" };
const _hoisted_36 = { class: "d-block text-black fw-medium mb-2" };
const _hoisted_37 = { class: "mb-0" };
const _hoisted_38 = { class: "col-md-12" };
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_41 = { class: "col-md-3 mb-20" };
const _hoisted_42 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_43 = { class: "form-check form-switch" };
const _hoisted_44 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_45 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_46 = {
    key: 0,
    class: "text-danger d-block mt-2"
};
const _hoisted_47 = { class: "col-md-12" };
const _hoisted_48 = { class: "form-group mb-15 mb-sm-20 mb-md-25 border p-3 rounded bg-light" };
const _hoisted_49 = { class: "d-block text-black fw-bold mb-15" };
const _hoisted_50 = { class: "row" };
const _hoisted_51 = { class: "col-md-6 mb-3" };
const _hoisted_52 = { class: "form-check form-switch custom-switch" };
const _hoisted_53 = {
    class: "form-check-label fw-medium ms-2",
    for: "isCustomizable"
};
const _hoisted_54 = { class: "col-md-6 mb-3" };
const _hoisted_55 = { class: "form-check form-switch custom-switch" };
const _hoisted_56 = {
    class: "form-check-label fw-medium ms-2",
    for: "showSizes"
};
const _hoisted_57 = { class: "col-md-12" };
const _hoisted_58 = { class: "d-block text-black fw-semibold mb-10 mt-2" };
const _hoisted_59 = { class: "d-flex gap-4" };
const _hoisted_60 = { class: "form-check" };
const _hoisted_61 = {
    class: "form-check-label",
    for: "showOnWeb"
};
const _hoisted_62 = { class: "form-check" };
const _hoisted_63 = {
    class: "form-check-label",
    for: "showOnApp"
};
const _hoisted_64 = { class: "col-md-12" };
const _hoisted_65 = { class: "form-group mb-15 mb-sm-20 mb-md-25 border p-3 rounded" };
const _hoisted_66 = { class: "d-flex justify-content-between align-items-center mb-15" };
const _hoisted_67 = { class: "text-black fw-bold mb-0" };
const _hoisted_68 = { class: "form-check form-switch" };
const _hoisted_69 = { class: "form-check-label small ms-1" };
const _hoisted_70 = {
    key: 0,
    class: "row"
};
const _hoisted_71 = { class: "col-md-8 mb-3" };
const _hoisted_72 = { class: "d-block text-black fw-medium mb-1" };
const _hoisted_73 = { class: "col-md-4 mb-3" };
const _hoisted_74 = { class: "d-block text-black fw-medium mb-1" };
const _hoisted_75 = { class: "d-flex align-items-center gap-2 mt-1" };
const _hoisted_76 = { class: "text-muted font-monospace small" };
const _hoisted_77 = { class: "col-md-12" };
const _hoisted_78 = { class: "d-block text-black fw-medium mb-10" };
const _hoisted_79 = { class: "row" };
const _hoisted_80 = { class: "col-md-6 mb-3" };
const _hoisted_81 = { class: "text-muted d-block mb-1" };
const _hoisted_82 = { class: "col-md-6 mb-3" };
const _hoisted_83 = { class: "text-muted d-block mb-1" };
const _hoisted_84 = { class: "col-md-12" };
const _hoisted_85 = { class: "form-group mb-15 mb-sm-20 mb-md-25 border p-3 rounded" };
const _hoisted_86 = { class: "d-block text-black fw-bold mb-10" };
const _hoisted_87 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_88 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_89 = {
    key: 0,
    class: "ms-1 opacity-75"
};
const _hoisted_90 = {
    key: 1,
    class: "text-muted small italic mb-0"
};
const _hoisted_91 = {
    key: 1,
    class: "col-md-12"
};
const _hoisted_92 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_93 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_94 = {
    class: "btn btn-outline-warning",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contentModalScrollable_pizzaIngredients"
};
const _hoisted_95 = { class: "mt-2" };
const _hoisted_96 = {
    key: 0,
    class: "d-flex flex-wrap gap-1"
};
const _hoisted_97 = ["onClick"];
const _hoisted_98 = {
    key: 1,
    class: "text-muted small"
};
const _hoisted_99 = { class: "col-md-12" };
const _hoisted_100 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_101 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_102 = {
    class: "btn btn-outline-success",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contentModalScrollable_supplements"
};
const _hoisted_103 = { class: "mt-2" };
const _hoisted_104 = {
    key: 0,
    class: "d-flex flex-wrap gap-1"
};
const _hoisted_105 = ["onClick"];
const _hoisted_106 = {
    key: 1,
    class: "text-muted small"
};
const _hoisted_107 = { class: "col-md-12" };
const _hoisted_108 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_109 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_110 = ["placeholder"];
const _hoisted_111 = { class: "col-md-12" };
const _hoisted_112 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_113 = ["src"];
const _hoisted_114 = { class: "mb-3" };
const _hoisted_115 = {
    class: "btn-group",
    role: "group"
};
const _hoisted_116 = { key: 1 };
const _hoisted_117 = ["placeholder", "required"];
const _hoisted_118 = { class: "text-muted d-block mt-2" };
const _hoisted_119 = { key: 2 };
const _hoisted_120 = ["placeholder", "required"];
const _hoisted_121 = { class: "text-muted d-block mt-2" };
const _hoisted_122 = { class: "col-md-6" };
const _hoisted_123 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_124 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_125 = {
    class: "btn btn-outline-warning",
    type: "button",
    "data-bs-toggle": "modal",
    "data-bs-target": "#contentModalScrollable_productSize"
};
const _hoisted_126 = { class: "bg-transparent p-0 border-0 text-warning lh-1 fw-medium" };
const _hoisted_127 = { class: "position-relative" };
const _hoisted_128 = { class: "col-md-12" };
const _hoisted_129 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_130 = ["disabled"];
const _hoisted_131 = { class: "position-relative" };
const _hoisted_132 = {
    class: "modal fade",
    id: "contentModalScrollable_productSize",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_133 = { class: "modal-dialog modal-dialog-scrollable modal-xl" };
const _hoisted_134 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_135 = { class: "modal-header" };
const _hoisted_136 = { class: "modal-title fs-5" };
const _hoisted_137 = { class: "modal-body" };
const _hoisted_138 = { class: "flex-column" };
const _hoisted_139 = { class: "row" };
const _hoisted_140 = { class: "col-md-12 mb-4" };
const _hoisted_141 = { class: "d-flex align-items-center" };
const _hoisted_142 = { class: "me-2 fw-medium text-black" };
const _hoisted_143 = { class: "d-flex gap-2" };
const _hoisted_144 = ["onClick"];
const _hoisted_145 = { class: "col-md-9" };
const _hoisted_146 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_147 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_148 = ["placeholder", "required"];
const _hoisted_149 = { class: "col-md-3" };
const _hoisted_150 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_151 = { class: "col-md-6" };
const _hoisted_152 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_153 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_154 = ["required"];
const _hoisted_155 = { class: "col-md-6" };
const _hoisted_156 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_157 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_158 = ["required"];
const _hoisted_159 = { class: "col-md-12" };
const _hoisted_160 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_161 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_162 = { class: "mb-0" };
const _hoisted_163 = { class: "col-md-12" };
const _hoisted_164 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_165 = { class: "table-responsive" };
const _hoisted_166 = { class: "table align-middle mb-0" };
const _hoisted_167 = { class: "bg-success text-white" };
const _hoisted_168 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_169 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_170 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_171 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0",
    style: { "min-width": "250px" }
};
const _hoisted_172 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_173 = { key: 0 };
const _hoisted_174 = { class: "shadow-none lh-1 fw-bold ps-0" };
const _hoisted_175 = { class: "text-decoration-none text-black-emphasis" };
const _hoisted_176 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_177 = { class: "badge text-outline-danger" };
const _hoisted_178 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_179 = { class: "badge text-outline-danger" };
const _hoisted_180 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_181 = { class: "text-black-emphasis" };
const _hoisted_182 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_183 = {
    key: 0,
    class: "text-decoration-none text-black-emphasis"
};
const _hoisted_184 = {
    key: 1,
    class: "text-decoration-none text-black-emphasis"
};
const _hoisted_185 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" };
const _hoisted_186 = ["onClick", "title"];
const _hoisted_187 = ["onClick", "title"];
const _hoisted_188 = { key: 1 };
const _hoisted_189 = { class: "d-flex justify-content-center align-items-center mt-8" };
const _hoisted_190 = {
    class: "modal fade",
    id: "contentModalScrollable_pizzaIngredients",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_191 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_192 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_193 = { class: "modal-header" };
const _hoisted_194 = { class: "modal-title fs-5" };
const _hoisted_195 = { class: "modal-body" };
const _hoisted_196 = { class: "flex-column" };
const _hoisted_197 = { class: "row" };
const _hoisted_198 = { class: "col-md-12" };
const _hoisted_199 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_200 = { class: "position-relative" };
const _hoisted_201 = ["placeholder"];
const _hoisted_202 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_203 = { class: "list-group" };
const _hoisted_204 = ["onClick"];
const _hoisted_205 = {
    key: 1,
    class: "mt-2 text-muted"
};
const _hoisted_206 = { class: "mt-3" };
const _hoisted_207 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_208 = {
    key: 0,
    class: "d-flex flex-wrap gap-2"
};
const _hoisted_209 = ["onClick"];
const _hoisted_210 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_211 = { class: "d-flex justify-content-center align-items-center mt-8" };
const _hoisted_212 = {
    class: "modal fade",
    id: "contentModalScrollable_supplements",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_213 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_214 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_215 = { class: "modal-header" };
const _hoisted_216 = { class: "modal-title fs-5" };
const _hoisted_217 = { class: "modal-body" };
const _hoisted_218 = { class: "flex-column" };
const _hoisted_219 = { class: "row" };
const _hoisted_220 = { class: "col-md-12" };
const _hoisted_221 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_222 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_223 = { class: "position-relative" };
const _hoisted_224 = ["placeholder"];
const _hoisted_225 = {
    key: 0,
    class: "mt-2"
};
const _hoisted_226 = { class: "list-group" };
const _hoisted_227 = ["onClick"];
const _hoisted_228 = {
    key: 1,
    class: "mt-2 text-muted"
};
const _hoisted_229 = { class: "mt-3" };
const _hoisted_230 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_231 = {
    key: 0,
    class: "d-flex flex-wrap gap-2"
};
const _hoisted_232 = ["onClick"];
const _hoisted_233 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_234 = { class: "d-flex justify-content-center align-items-center mt-8" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                _createVNode(_component_v_select, {
                    modelValue: _ctx.selectedLanguage,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedLanguage) = $event)),
                    options: _ctx.availableLanguages,
                    label: "name",
                    reduce: (lang) => lang.code,
                    class: "language-selector",
                    style: { "min-width": "150px" }
                }, null, 8, ["modelValue", "options", "reduce"]),
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: lang.code,
                            class: _normalizeClass(["badge",
                                _ctx.isTranslationComplete(lang.code) ? 'bg-success' : 'bg-secondary'
                            ]),
                            style: { "cursor": "pointer" },
                            onClick: ($event) => (_ctx.selectedLanguage = lang.code),
                            title: _ctx.isTranslationComplete(lang.code)
                                ? `${lang.name} - ${_ctx.$t('product.complete')}`
                                : `${lang.name} - ${_ctx.$t('product.incomplete')}`
                        }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_6));
                    }), 128))
                ])
            ]),
            _createElementVNode("form", {
                onSubmit: _cache[32] || (_cache[32] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.uploadLogo && _ctx.uploadLogo(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.productData.name) }]),
                                placeholder: _ctx.$t('forms.example') + ' ' + _ctx.$t('product.productName'),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.productData.name) = $event)),
                                onChange: _cache[2] || (_cache[2] = (event) => _ctx.handleInput(event, 'name')),
                                required: ""
                            }, null, 42, _hoisted_11), [
                                [_vModelText, _ctx.productData.name]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.description')), 1),
                            _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_QuillEditor, {
                                    theme: "snow",
                                    "content-type": "html",
                                    placeholder: _ctx.$t('product.productDescription'),
                                    toolbar: "full",
                                    content: _ctx.productData.description,
                                    "onUpdate:content": _cache[3] || (_cache[3] = ($event) => ((_ctx.productData.description) = $event))
                                }, null, 8, ["placeholder", "content"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('product.nutritionalValues')), 1),
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_QuillEditor, {
                                    theme: "snow",
                                    "content-type": "html",
                                    placeholder: _ctx.$t('product.giveNote'),
                                    toolbar: "full",
                                    content: _ctx.productData.longDescription,
                                    "onUpdate:content": _cache[4] || (_cache[4] = ($event) => ((_ctx.productData.longDescription) = $event))
                                }, null, 8, ["placeholder", "content"])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('product.multilingualTranslations')) + " - " + _toDisplayString(_ctx.getCurrentLanguageName()), 1),
                                (_ctx.isTranslationComplete(_ctx.selectedLanguage))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                                        _cache[51] || (_cache[51] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('product.complete')), 1)
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                        _cache[52] || (_cache[52] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('product.incomplete')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('common.name')) + " * ", 1),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: `${_ctx.$t('product.productNameInLanguage')} ${_ctx.getCurrentLanguageName()}`,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.currentTranslation.name) = $event)),
                                                onBlur: _cache[6] || (_cache[6] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                            }, null, 40, _hoisted_31), [
                                                [_vModelText, _ctx.currentTranslation.name]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                            _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('common.description')), 1),
                                            _createElementVNode("div", _hoisted_34, [
                                                (_openBlock(), _createBlock(_component_QuillEditor, {
                                                    key: `description-${_ctx.selectedLanguage}-${_ctx.translationKey}`,
                                                    theme: "snow",
                                                    "content-type": "html",
                                                    placeholder: `${_ctx.$t('product.descriptionInLanguage')} ${_ctx.getCurrentLanguageName()}`,
                                                    toolbar: "full",
                                                    content: _ctx.currentTranslation.description,
                                                    "onUpdate:content": [
                                                        _cache[7] || (_cache[7] = ($event) => ((_ctx.currentTranslation.description) = $event)),
                                                        _cache[8] || (_cache[8] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                                    ]
                                                }, null, 8, ["placeholder", "content"]))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('product.nutritionalValues')), 1),
                                            _createElementVNode("div", _hoisted_37, [
                                                (_openBlock(), _createBlock(_component_QuillEditor, {
                                                    key: `longDescription-${_ctx.selectedLanguage}-${_ctx.translationKey}`,
                                                    theme: "snow",
                                                    "content-type": "html",
                                                    placeholder: `${_ctx.$t('product.notesInLanguage')} ${_ctx.getCurrentLanguageName()}`,
                                                    toolbar: "full",
                                                    content: _ctx.currentTranslation.longDescription,
                                                    "onUpdate:content": [
                                                        _cache[9] || (_cache[9] = ($event) => ((_ctx.currentTranslation.longDescription) = $event)),
                                                        _cache[10] || (_cache[10] = ($event) => (_ctx.saveTranslation(_ctx.selectedLanguage)))
                                                    ]
                                                }, null, 8, ["placeholder", "content"]))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('feature.features') || 'features'), 1),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.productData.features,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.productData.features) = $event)),
                                options: _ctx.featuresOptions,
                                multiple: "",
                                label: "name",
                                reduce: (feature) => feature.id,
                                placeholder: _ctx.$t('forms.searchFeaturePlaceholder')
                            }, null, 8, ["modelValue", "options", "reduce", "placeholder"])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('product.removeAllOptions')), 1),
                        _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.deleteAllOptions) = $event)),
                                onChange: _cache[13] || (_cache[13] =
                                    //@ts-ignore
                                    (...args) => (_ctx.toggleDeleAllOptions && _ctx.toggleDeleAllOptions(...args)))
                            }, null, 544), [
                                [_vModelCheckbox, _ctx.deleteAllOptions]
                            ])
                        ])
                    ]),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                                _cache[53] || (_cache[53] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Restaurant * ", -1)),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedRestaurant,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                    options: _ctx.restaurantOptions,
                                    label: "name",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: _ctx.actionDetected === 'edit' &&
                                        _ctx.categoryRestaurantId &&
                                        _ctx.selectedRestaurant !== _ctx.categoryRestaurantId
                                        ? 'Choisissez le restaurant approprié'
                                        : 'Sélectionner un restaurant',
                                    class: "restaurant-select",
                                    onInput: _ctx.onRestaurantChange
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"]),
                                (_ctx.actionDetected === 'edit' &&
                                    _ctx.categoryRestaurantId &&
                                    _ctx.selectedRestaurant &&
                                    _ctx.selectedRestaurant !== _ctx.categoryRestaurantId)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_46, " ⚠️ " + _toDisplayString(_ctx.$t('product.restaurantNotMatchCategory')), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("label", _hoisted_49, [
                                _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fas fa-desktop me-2" }, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t('product.displaySettings')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("div", _hoisted_52, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "isCustomizable",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.productData.isCustomizable) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.productData.isCustomizable]
                                        ]),
                                        _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('product.isCustomizable')), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "showSizes",
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.productData.showSizes) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.productData.showSizes]
                                        ]),
                                        _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('product.showSizes')), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('product.visibility')), 1),
                                    _createElementVNode("div", _hoisted_59, [
                                        _createElementVNode("div", _hoisted_60, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: "showOnWeb",
                                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.productData.showOnWeb) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.productData.showOnWeb]
                                            ]),
                                            _createElementVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('product.showOnWeb')), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_62, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                id: "showOnApp",
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.productData.showOnApp) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _ctx.productData.showOnApp]
                                            ]),
                                            _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t('product.showOnApp')), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("label", _hoisted_67, [
                                    _cache[55] || (_cache[55] = _createElementVNode("i", { class: "fas fa-bullhorn me-2" }, null, -1)),
                                    _createTextVNode(_toDisplayString(_ctx.$t('product.promotionBanner')), 1)
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.productData.banner.isActive) = $event))
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.productData.banner.isActive]
                                    ]),
                                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('product.bannerActive')), 1)
                                ])
                            ]),
                            (_ctx.productData.banner.isActive)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                        _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('product.bannerText')) + " (" + _toDisplayString(_ctx.getCurrentLanguageName()) + ")", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0",
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.currentBannerTranslation.text) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.currentBannerTranslation.text]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('product.bannerColor')), 1),
                                        _createElementVNode("div", _hoisted_75, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "color",
                                                class: "form-control form-control-color border-0 p-0",
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.productData.banner.color) = $event)),
                                                style: { "width": "45px", "height": "35px", "cursor": "pointer" }
                                            }, null, 512), [
                                                [_vModelText, _ctx.productData.banner.color]
                                            ]),
                                            _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.productData.banner.color.toUpperCase()), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                        _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('product.bannerDuration')), 1),
                                        _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                                _createElementVNode("small", _hoisted_81, _toDisplayString(_ctx.$t('product.startDate')), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "date",
                                                    class: "form-control shadow-none rounded-0",
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.productData.banner.startDate) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _ctx.productData.banner.startDate]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_82, [
                                                _createElementVNode("small", _hoisted_83, _toDisplayString(_ctx.$t('product.endDate')), 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "date",
                                                    class: "form-control shadow-none rounded-0",
                                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.productData.banner.endDate) = $event))
                                                }, null, 512), [
                                                    [_vModelText, _ctx.productData.banner.endDate]
                                                ])
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("label", _hoisted_86, [
                                _cache[56] || (_cache[56] = _createElementVNode("i", { class: "fas fa-tags me-2" }, null, -1)),
                                _createTextVNode(_toDisplayString(_ctx.$t('product.personalizationCategories')), 1)
                            ]),
                            _createVNode(_component_v_select, {
                                modelValue: _ctx.productData.ingredientCategories,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.productData.ingredientCategories) = $event)),
                                options: _ctx.ingredientCategoriesOptions,
                                multiple: "",
                                label: "name",
                                reduce: (cat) => cat.id,
                                placeholder: _ctx.$t('product.manageIngredientCategories'),
                                loading: _ctx.isLoadingIngredientCategories,
                                class: "mb-2"
                            }, null, 8, ["modelValue", "options", "reduce", "placeholder", "loading"]),
                            (_ctx.productData.ingredientCategories.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                    _createElementVNode("div", _hoisted_88, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productData.ingredientCategories, (catId) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: catId,
                                                class: "badge bg-info text-white rounded-pill px-3 py-2"
                                            }, [
                                                _createTextVNode(_toDisplayString(_ctx.ingredientCategoriesOptions.find(o => o.id === catId)?.name || catId) + " ", 1),
                                                (_ctx.ingredientCategoriesOptions.find(o => o.id === catId)?.maxAdditions)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_89, " (Max: " + _toDisplayString(_ctx.ingredientCategoriesOptions.find(o => o.id === catId).maxAdditions) + ") ", 1))
                                                    : _createCommentVNode("", true)
                                            ]));
                                        }), 128))
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.$t('product.noIngredientCategorySelected')), 1))
                        ])
                    ]),
                    (_ctx.isPizzaCategory)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                                _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.$t('product.baseIngredients')) + " * ", 1),
                                _createElementVNode("button", _hoisted_94, _toDisplayString(_ctx.actionDetected === "edit"
                                    ? _ctx.$t('product.updateIngredients')
                                    : _ctx.$t('product.addBaseIngredients')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                                (_ctx.allPizzaIngredients.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPizzaIngredients, (ingredient) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: ingredient.id,
                                                class: "badge bg-warning text-dark px-2 py-1 rounded-pill d-flex align-items-center gap-1",
                                                style: { "font-size": "0.75rem" }
                                            }, [
                                                _createTextVNode(_toDisplayString(ingredient.name) + " ", 1),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (_ctx.removePizzaIngredient(ingredient)),
                                                    type: "button",
                                                    class: "btn-close btn-close-dark",
                                                    style: { "font-size": "0.5rem", "margin-left": "0.25rem" },
                                                    "aria-label": "Retirer l'ingrédient"
                                                }, null, 8, _hoisted_97)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_ctx.$t('product.noIngredientSelected')), 1))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", _hoisted_100, [
                            _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t('product.baseSupplements')), 1),
                            _createElementVNode("button", _hoisted_102, _toDisplayString(_ctx.actionDetected === "edit"
                                ? _ctx.$t('product.updateSupplements')
                                : _ctx.$t('product.addBaseSupplements')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                            (_ctx.allProductSupplements.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProductSupplements, (supplement) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                            key: supplement.id,
                                            class: "badge bg-success text-white px-2 py-1 rounded-pill d-flex align-items-center gap-1",
                                            style: { "font-size": "0.75rem" }
                                        }, [
                                            _createTextVNode(_toDisplayString(supplement.name) + " ", 1),
                                            _createElementVNode("button", {
                                                onClick: ($event) => (_ctx.removeProductSupplement(supplement)),
                                                type: "button",
                                                class: "btn-close btn-close-white",
                                                style: { "font-size": "0.5rem", "margin-left": "0.25rem" },
                                                "aria-label": "Retirer le supplément"
                                            }, null, 8, _hoisted_105)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_106, _toDisplayString(_ctx.$t('product.noSupplementSelected')), 1))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                            _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.$t('product.positioning')), 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('forms.example') + ' ' + _ctx.$t('product.productName'),
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.productData.position) = $event))
                            }, null, 8, _hoisted_110), [
                                [_vModelText, _ctx.productData.position]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                            _cache[59] || (_cache[59] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, " Image * ", -1)),
                            (_ctx.productData.image_urls.length > 0)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.productData.image_urls[0],
                                    class: "rounded-circle me-8 mb-4",
                                    width: "45",
                                    height: "45",
                                    alt: "produit"
                                }, null, 8, _hoisted_113))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["btn",
                                            _ctx.imageInputMode === 'upload'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]),
                                        onClick: _cache[26] || (_cache[26] = ($event) => (_ctx.imageInputMode = 'upload'))
                                    }, [
                                        _cache[57] || (_cache[57] = _createElementVNode("i", { class: "fas fa-upload me-2" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('product.uploadFile')), 1)
                                    ], 2),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: _normalizeClass(["btn",
                                            _ctx.imageInputMode === 'url'
                                                ? 'btn-primary'
                                                : 'btn-outline-primary'
                                        ]),
                                        onClick: _cache[27] || (_cache[27] = ($event) => (_ctx.imageInputMode = 'url'))
                                    }, [
                                        _cache[58] || (_cache[58] = _createElementVNode("i", { class: "fas fa-link me-2" }, null, -1)),
                                        _createTextVNode(_toDisplayString(_ctx.$t('product.httpsLink')), 1)
                                    ], 2)
                                ])
                            ]),
                            (_ctx.imageInputMode === 'upload')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                    _createElementVNode("input", {
                                        type: "file",
                                        class: "form-control shadow-none rounded-0 text-black",
                                        placeholder: _ctx.$t('forms.chooseFile'),
                                        onChange: _cache[28] || (_cache[28] = (event) => _ctx.handleInput(event, 'file')),
                                        required: _ctx.actionDetected === 'add' && _ctx.imageInputMode === 'upload',
                                        accept: "image/jpeg,image/png,image/webp"
                                    }, null, 40, _hoisted_117),
                                    _createElementVNode("small", _hoisted_118, _toDisplayString(_ctx.$t('product.acceptedFormats')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.imageInputMode === 'url')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "url",
                                        class: "form-control shadow-none rounded-0 text-black",
                                        placeholder: _ctx.$t('forms.imageUrlPlaceholder'),
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((_ctx.imageUrl) = $event)),
                                        onChange: _cache[30] || (_cache[30] = (event) => _ctx.handleInput(event, 'imageUrl')),
                                        required: _ctx.actionDetected === 'add' && _ctx.imageInputMode === 'url'
                                    }, null, 40, _hoisted_120), [
                                        [_vModelText, _ctx.imageUrl]
                                    ]),
                                    _createElementVNode("small", _hoisted_121, _toDisplayString(_ctx.$t('product.enterValidHttpsUrl')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
                    _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("div", _hoisted_123, [
                            _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t('product.productVariation')) + "* ", 1),
                            _createElementVNode("button", _hoisted_125, _toDisplayString(_ctx.actionDetected === "edit"
                                ? _ctx.$t('product.updateVariation')
                                : _ctx.$t('product.addVariation')), 1)
                        ]),
                        _createElementVNode("span", _hoisted_126, [
                            _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.allVariationsProduct.length > 0
                                ? `${_ctx.allVariationsProduct.length} ${_ctx.$t('product.sizes')}`
                                : _ctx.$t('product.noSize')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_128, [
                        (_ctx.actionDetected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected === "edit"
                                        ? _ctx.$t('product.update')
                                        : _ctx.$t('product.addProduct')), 11, _hoisted_130)),
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[31] || (_cache[31] =
                                        //@ts-ignore
                                        (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                    class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                }, [
                                    _cache[60] || (_cache[60] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                    _createElementVNode("span", _hoisted_131, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 32)
        ]),
        _createElementVNode("div", _hoisted_132, [
            _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("h1", _hoisted_136, _toDisplayString(_ctx.$t('product.specifyProductSizes')), 1),
                        _cache[62] || (_cache[62] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("div", _hoisted_138, [
                            _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                    _createElementVNode("div", _hoisted_141, [
                                        _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t('common.language')) + ":", 1),
                                        _createElementVNode("div", _hoisted_143, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                                                return (_openBlock(), _createElementBlock("span", {
                                                    key: `var-lang-${lang.code}`,
                                                    class: _normalizeClass(["badge",
                                                        _ctx.selectedVariationLanguage === lang.code
                                                            ? 'bg-primary'
                                                            : _ctx.isVariationTranslationComplete(lang.code)
                                                                ? 'bg-success'
                                                                : 'bg-secondary'
                                                    ]),
                                                    style: { "cursor": "pointer" },
                                                    onClick: ($event) => (_ctx.selectedVariationLanguage = lang.code)
                                                }, _toDisplayString(lang.code.toUpperCase()), 11, _hoisted_144));
                                            }), 128))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_145, [
                                    _createElementVNode("div", _hoisted_146, [
                                        _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t('product.size')) + " (" + _toDisplayString(_ctx.selectedVariationLanguage.toUpperCase()) + ")* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: _ctx.$t('forms.sizePlaceholder'),
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((_ctx.getVariationTranslation(_ctx.selectedVariationLanguage).size) = $event)),
                                            onInput: _cache[34] || (_cache[34] =
                                                () => {
                                                    if (_ctx.selectedVariationLanguage === 'fr')
                                                        _ctx.productSizeDefine.size =
                                                            _ctx.getVariationTranslation('fr').size;
                                                }),
                                            required: _ctx.selectedVariationLanguage === 'fr' &&
                                                _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_148), [
                                            [_vModelText,
                                                _ctx.getVariationTranslation(_ctx.selectedVariationLanguage).size
                                            ]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_149, [
                                    _createElementVNode("div", _hoisted_150, [
                                        _cache[63] || (_cache[63] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Position (1: Au centre, 2: Gauche / haute, 3: Droite / bas) ", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "number",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "0",
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((_ctx.productSizeDefine.position) = $event))
                                        }, null, 512), [
                                            [_vModelText, _ctx.productSizeDefine.position]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("div", _hoisted_152, [
                                        _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t('product.takeawayPrice')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "12.90",
                                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((_ctx.productSizeDefine.takeawayPrice) = $event)),
                                            onChange: _cache[37] || (_cache[37] = (event) => _ctx.handleInput(event, 'takeawayPrice')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_154), [
                                            [_vModelText, _ctx.productSizeDefine.takeawayPrice]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_155, [
                                    _createElementVNode("div", _hoisted_156, [
                                        _createElementVNode("label", _hoisted_157, _toDisplayString(_ctx.$t('product.deliveryPriceLabel')) + "* ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 text-black",
                                            placeholder: "12.90",
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((_ctx.productSizeDefine.deliveryPrice) = $event)),
                                            onChange: _cache[39] || (_cache[39] = (event) => _ctx.handleInput(event, 'deliveryPrice')),
                                            required: _ctx.actionDetected === 'add'
                                        }, null, 40, _hoisted_158), [
                                            [_vModelText, _ctx.productSizeDefine.deliveryPrice]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_159, [
                                    _createElementVNode("div", _hoisted_160, [
                                        _createElementVNode("label", _hoisted_161, _toDisplayString(_ctx.$t('product.specificSizeDescription')) + " (" + _toDisplayString(_ctx.selectedVariationLanguage.toUpperCase()) + ") ", 1),
                                        _createElementVNode("div", _hoisted_162, [
                                            (_openBlock(), _createBlock(_component_QuillEditor, {
                                                key: `var-desc-${_ctx.selectedVariationLanguage}`,
                                                theme: "snow",
                                                "content-type": "html",
                                                placeholder: _ctx.$t('forms.sizeDescriptionPlaceholder'),
                                                toolbar: [
                                                    ['bold', 'italic', 'underline', 'strike'],
                                                    ['blockquote', 'code-block'],
                                                    [{ header: 1 }, { header: 2 }],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    [{ script: 'sub' }, { script: 'super' }],
                                                    [{ indent: '-1' }, { indent: '+1' }],
                                                    [{ direction: 'rtl' }],
                                                    [{ size: ['small', false, 'large', 'huge'] }],
                                                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                    [{ color: [] }, { background: [] }],
                                                    [{ font: [] }],
                                                    [{ align: [] }],
                                                    ['clean'],
                                                    ['link'],
                                                ],
                                                content: _ctx.getVariationTranslation(_ctx.selectedVariationLanguage)
                                                    .description,
                                                "onUpdate:content": [
                                                    _cache[40] || (_cache[40] = ($event) => ((_ctx.getVariationTranslation(_ctx.selectedVariationLanguage)
                                                        .description) = $event)),
                                                    _cache[41] || (_cache[41] =
                                                        () => {
                                                            if (_ctx.selectedVariationLanguage === 'fr')
                                                                _ctx.productSizeDefine.generalDescription =
                                                                    _ctx.getVariationTranslation('fr').description;
                                                        })
                                                ]
                                            }, null, 8, ["placeholder", "content"]))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_163, [
                                    _createElementVNode("div", _hoisted_164, [
                                        _createElementVNode("button", {
                                            onClick: _cache[42] || (_cache[42] =
                                                //@ts-ignore
                                                (...args) => (_ctx.addSizeVariation && _ctx.addSizeVariation(...args))),
                                            class: "btn btn-warning btn-sm",
                                            type: "button"
                                        }, _toDisplayString(_ctx.isEditingVariation ? 'Mettre à jour' : 'Ajouter'), 1),
                                        (_ctx.isEditingVariation)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                onClick: _cache[43] || (_cache[43] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.cancelEditVariation && _ctx.cancelEditVariation(...args))),
                                                class: "btn btn-secondary btn-sm ms-2",
                                                type: "button"
                                            }, " Annuler "))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_165, [
                                _createElementVNode("table", _hoisted_166, [
                                    _createElementVNode("thead", _hoisted_167, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", _hoisted_168, _toDisplayString(_ctx.$t('product.SIZE')), 1),
                                            _createElementVNode("th", _hoisted_169, _toDisplayString(_ctx.$t('product.TAKEAWAY_PRICE')), 1),
                                            _createElementVNode("th", _hoisted_170, _toDisplayString(_ctx.$t('product.DELIVERY_PRICE')), 1),
                                            _cache[64] || (_cache[64] = _createElementVNode("th", {
                                                scope: "col",
                                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                                            }, " Position ", -1)),
                                            _createElementVNode("th", _hoisted_171, _toDisplayString(_ctx.$t('product.DESCRIPTION')), 1),
                                            _createElementVNode("th", _hoisted_172, _toDisplayString(_ctx.$t('product.ACTIONS')), 1)
                                        ])
                                    ]),
                                    (_ctx.allVariationsProduct && _ctx.allVariationsProduct.length > 0)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_173, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allVariationsProduct, (variation, index) => {
                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("th", _hoisted_174, [
                                                        _createElementVNode("span", _hoisted_175, _toDisplayString(variation.size), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_176, [
                                                        _createElementVNode("span", _hoisted_177, _toDisplayString(variation.takeawayPrice) + " CHF", 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_178, [
                                                        _createElementVNode("span", _hoisted_179, _toDisplayString(variation.deliveryPrice) + " CHF", 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_180, [
                                                        _createElementVNode("span", _hoisted_181, _toDisplayString(variation.position || 0), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_182, [
                                                        (variation.description)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_183, _toDisplayString(_ctx.cleanAndTruncateHtmlText(variation.description)), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_184, "-"))
                                                    ]),
                                                    _createElementVNode("td", _hoisted_185, [
                                                        _createElementVNode("span", {
                                                            onClick: ($event) => (_ctx.editSizeVariation(variation, index)),
                                                            class: "text-primary cursor-pointer me-3 fs-20",
                                                            title: _ctx.$t('product.modifier')
                                                        }, [...(_cache[65] || (_cache[65] = [
                                                                _createElementVNode("i", { class: "flaticon-pen" }, null, -1)
                                                            ]))], 8, _hoisted_186),
                                                        _createElementVNode("span", {
                                                            onClick: ($event) => (_ctx.removeSizeVariation(variation)),
                                                            class: "text-danger cursor-pointer fs-20",
                                                            title: _ctx.$t('product.remove')
                                                        }, [...(_cache[66] || (_cache[66] = [
                                                                _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                                            ]))], 8, _hoisted_187)
                                                    ])
                                                ]));
                                            }), 128))
                                        ]))
                                        : (_openBlock(), _createElementBlock("tbody", _hoisted_188, [
                                            _createElementVNode("tr", null, [
                                                _createVNode(_component_EmptyTable, {
                                                    message: _ctx.$t('product.noSizeAdded'),
                                                    colspan: 5,
                                                    textClass: "text-muted"
                                                }, null, 8, ["message"])
                                            ])
                                        ]))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_189, [
                                _createElementVNode("button", {
                                    onClick: _cache[44] || (_cache[44] = ($event) => (_ctx.updateVariationProduct(_ctx.productResponse?.id, _ctx.allVariationsProduct))),
                                    class: "btn btn-primary btn-sm",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, _toDisplayString(_ctx.$t('product.validate')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
                _createElementVNode("div", _hoisted_192, [
                    _createElementVNode("div", _hoisted_193, [
                        _createElementVNode("h1", _hoisted_194, _toDisplayString(_ctx.$t('product.selectPizzaBaseIngredients')), 1),
                        _cache[67] || (_cache[67] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_195, [
                        _createElementVNode("div", _hoisted_196, [
                            _createElementVNode("div", _hoisted_197, [
                                _createElementVNode("div", _hoisted_198, [
                                    _createElementVNode("div", _hoisted_199, [
                                        _cache[70] || (_cache[70] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Rechercher un ingrédient de base ", -1)),
                                        _createElementVNode("div", _hoisted_200, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: _ctx.$t('forms.searchIngredientPlaceholder'),
                                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((_ctx.searchIngredientQuery) = $event)),
                                                onInput: _cache[46] || (_cache[46] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.searchIngredients && _ctx.searchIngredients(...args)))
                                            }, null, 40, _hoisted_201), [
                                                [_vModelText, _ctx.searchIngredientQuery]
                                            ]),
                                            _cache[68] || (_cache[68] = _createElementVNode("i", { class: "fas fa-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted" }, null, -1))
                                        ]),
                                        (_ctx.searchResults.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_202, [
                                                _createElementVNode("div", _hoisted_203, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (ingredient) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: ingredient.id,
                                                            type: "button",
                                                            class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                                                            onClick: ($event) => (_ctx.selectIngredientFromSearch(ingredient))
                                                        }, [
                                                            _createElementVNode("span", null, _toDisplayString(ingredient.name), 1),
                                                            _cache[69] || (_cache[69] = _createElementVNode("i", { class: "fas fa-plus text-success" }, null, -1))
                                                        ], 8, _hoisted_204));
                                                    }), 128))
                                                ])
                                            ]))
                                            : (_ctx.searchIngredientQuery && !_ctx.isSearching)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('product.noIngredientFound')) + " \"" + _toDisplayString(_ctx.searchIngredientQuery) + "\"", 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_206, [
                                _createElementVNode("label", _hoisted_207, _toDisplayString(_ctx.$t('product.selectedIngredients')), 1),
                                (_ctx.allPizzaIngredients && _ctx.allPizzaIngredients.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPizzaIngredients, (ingredient) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: ingredient.id,
                                                class: "badge bg-primary text-white d-flex align-items-center gap-2 px-3 py-2 rounded-pill",
                                                style: { "font-size": "0.875rem" }
                                            }, [
                                                _createTextVNode(_toDisplayString(ingredient.name) + " ", 1),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (_ctx.removePizzaIngredient(ingredient)),
                                                    type: "button",
                                                    class: "btn-close btn-close-white",
                                                    style: { "font-size": "0.6rem", "margin-left": "0.25rem" },
                                                    "aria-label": "Retirer l'ingrédient"
                                                }, null, 8, _hoisted_209)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_210, [
                                        _createElementVNode("small", null, _toDisplayString(_ctx.$t('product.noIngredientSelected')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_211, [
                                _createElementVNode("button", {
                                    onClick: _cache[47] || (_cache[47] =
                                        //@ts-ignore
                                        (...args) => (_ctx.validatePizzaIngredients && _ctx.validatePizzaIngredients(...args))),
                                    class: "btn btn-primary btn-sm",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, _toDisplayString(_ctx.$t('product.validate')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_212, [
            _createElementVNode("div", _hoisted_213, [
                _createElementVNode("div", _hoisted_214, [
                    _createElementVNode("div", _hoisted_215, [
                        _createElementVNode("h1", _hoisted_216, _toDisplayString(_ctx.$t('product.selectBaseSupplements')), 1),
                        _cache[71] || (_cache[71] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_217, [
                        _createElementVNode("div", _hoisted_218, [
                            _createElementVNode("div", _hoisted_219, [
                                _createElementVNode("div", _hoisted_220, [
                                    _createElementVNode("div", _hoisted_221, [
                                        _createElementVNode("label", _hoisted_222, _toDisplayString(_ctx.$t('product.searchSupplement')), 1),
                                        _createElementVNode("div", _hoisted_223, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control shadow-none rounded-0 text-black",
                                                placeholder: _ctx.$t('forms.searchSupplementPlaceholder'),
                                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((_ctx.searchSupplementQuery) = $event)),
                                                onInput: _cache[49] || (_cache[49] =
                                                    //@ts-ignore
                                                    (...args) => (_ctx.searchSupplements && _ctx.searchSupplements(...args)))
                                            }, null, 40, _hoisted_224), [
                                                [_vModelText, _ctx.searchSupplementQuery]
                                            ]),
                                            _cache[72] || (_cache[72] = _createElementVNode("i", { class: "fas fa-search position-absolute top-50 end-0 translate-middle-y me-3 text-muted" }, null, -1))
                                        ]),
                                        (_ctx.supplementSearchResults.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                                                _createElementVNode("div", _hoisted_226, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplementSearchResults, (supplement) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            key: supplement.id,
                                                            type: "button",
                                                            class: "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                                                            onClick: ($event) => (_ctx.selectSupplementFromSearch(supplement))
                                                        }, [
                                                            _createElementVNode("span", null, _toDisplayString(supplement.name), 1),
                                                            _cache[73] || (_cache[73] = _createElementVNode("i", { class: "fas fa-plus text-success" }, null, -1))
                                                        ], 8, _hoisted_227));
                                                    }), 128))
                                                ])
                                            ]))
                                            : (_ctx.searchSupplementQuery && !_ctx.isSearchingSupplements)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                    _createElementVNode("small", null, _toDisplayString(_ctx.$t('product.noSupplementFound')) + " \"" + _toDisplayString(_ctx.searchSupplementQuery) + "\"", 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_229, [
                                _createElementVNode("label", _hoisted_230, _toDisplayString(_ctx.$t('product.selectedSupplements')), 1),
                                (_ctx.allProductSupplements && _ctx.allProductSupplements.length > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_231, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allProductSupplements, (supplement) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                                key: supplement.id,
                                                class: "badge bg-success text-white d-flex align-items-center gap-2 px-3 py-2 rounded-pill",
                                                style: { "font-size": "0.875rem" }
                                            }, [
                                                _createTextVNode(_toDisplayString(supplement.name) + " ", 1),
                                                _createElementVNode("button", {
                                                    onClick: ($event) => (_ctx.removeProductSupplement(supplement)),
                                                    type: "button",
                                                    class: "btn-close btn-close-white",
                                                    style: { "font-size": "0.6rem", "margin-left": "0.25rem" },
                                                    "aria-label": "Retirer le supplément"
                                                }, null, 8, _hoisted_232)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_233, [
                                        _createElementVNode("small", null, _toDisplayString(_ctx.$t('product.noSupplementSelected')), 1)
                                    ]))
                            ]),
                            _createElementVNode("div", _hoisted_234, [
                                _createElementVNode("button", {
                                    onClick: _cache[50] || (_cache[50] =
                                        //@ts-ignore
                                        (...args) => (_ctx.validateProductSupplements && _ctx.validateProductSupplements(...args))),
                                    class: "btn btn-success btn-sm",
                                    type: "button",
                                    "data-bs-dismiss": "modal",
                                    "aria-label": "Close"
                                }, _toDisplayString(_ctx.$t('product.validate')), 1)
                            ])
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
